<div class="content-container">
  <div class="top-bottom-container dropdown-container">
    <!-- Top or Bottom -->
    <mode-labeled-menu
      class="display-container"
      [label]="'Display'"
      [selected]="operator"
      [menuItems]="operatorMenuItems"
      (menuChange)="onChangeCondition($event)"
    ></mode-labeled-menu>
    <!-- limit input -->
    <div class="limit-container">
      <input
        data-test="limit-number-input"
        class="form-control form-control-sm range-input"
        placeholder="Enter a value"
        type="number"
        min="0"
        max="{{ MAX_LIMIT }}"
        [ngModel]="currentLimit"
        (ngModelChange)="onLimitChange($event)"
        (keydown.enter)="$event.target.blur()"
        (keypress)="validateInput($event)"
      />
    </div>
  </div>
  <!-- By-field -->
  <mode-labeled-field-list-menu
    [label]="'Field'"
    [selected]="byFieldAttr"
    [fieldsInEncoding]="encodingByFieldAttrs"
    [otherFields]="otherByFieldAttrs"
    (menuChange)="onChangeField($event)"
  ></mode-labeled-field-list-menu>
  <!-- Aggregation -->
  <mode-labeled-menu
    class="dropdown-container"
    [label]="'Aggregation'"
    [selected]="aggrFunc"
    [menuItems]="allowedAggrFuncs"
    (menuChange)="onChangeAggregation($event)"
  ></mode-labeled-menu>
  <!-- Filter order -->
  <mode-labeled-menu
    class="dropdown-container"
    [label]="'Filter order'"
    [selected]="sequence"
    [menuItems]="sequenceMenuItems"
    (menuChange)="onChangeSequence($event)"
  ></mode-labeled-menu>
  <div class="filter-desc" [ngSwitch]="sequence.value">
    <div *ngSwitchCase="TopNSequence.FirstIsolate">
      Limit to the <span>{{ filterOperatorDisplayValue }} {{ currentLimit }}</span> values from
      <span>{{ filterField?.displayName }}</span
      >, then apply any other visualization filters.
    </div>
    <div *ngSwitchCase="TopNSequence.LastIsolate">
      Apply any other visualization filters, then limit to the
      <span>{{ filterOperatorDisplayValue }} {{ currentLimit }}</span> values from
      <span>{{ filterField?.displayName }}</span
      >.
    </div>
  </div>
</div>
